module.exports = __webpack_public_path__ + "img/img_sld3.52f663fa.png";